import { X, LogOut } from "react-feather";

interface UserMenuNNHeaderProps {
  title?: string;
  BackIcon?: any;
  onLogout?: () => void;
  onBack?: () => void;
}

export const UserMenuNNHeader = ({
  title = "Mein Profil",
  BackIcon = X,
  onLogout,
  onBack,
}: UserMenuNNHeaderProps) => {
  return (
    <div className="user-menu__header">
      {onBack && (
        <button type="button"
          aria-label="Zurück"
          onClick={() => {
            onBack();
          }}
        >
          <BackIcon />
        </button>
      )}
      {!onBack && <span></span>}
      <p className="user-menu__header-title">{title}</p>
      {onLogout && (
        <button type="button" className="user-menu__header-logout" onClick={onLogout} aria-label="Abmelden">
          <LogOut className="" />
        </button>
      )}
    </div>
  );
};
